const formatDate = (rawDateText: string): string => {
  const split = rawDateText.split(/T|-|:/);
  const year = split[0];
  const month = split[1];
  const day = split[2];
  return `${year}/${month}/${day}`;
};

export default formatDate;
